"use client";

import { useQuery } from "@tanstack/react-query";
import gql from "graphql-tag";
import type { GeneratedQuery } from "@aws-amplify/api-graphql";
import { fetchGraphQLClient } from "../../../amplify/fetchGraphQLClient";
import type { AccommodationForm } from "./useCreateAccommodationForm";

interface GetAccommodationFormQueryVariables {
  id: string;
}

export const getAccommodationFormQuery = gql`
  query getAccommodationForm($id: ID!) {
    getAccommodationForm(id: $id) {
      id
      patientId
      episodeOfCareId
      status
      formData
      createdAt
      updatedAt
      submittedAt
      signedAt
      createdBy
    }
  }
`.loc?.source.body as GeneratedQuery<
  GetAccommodationFormQueryVariables,
  {
    getAccommodationForm: AccommodationForm | null;
  }
>;

interface UseGetAccommodationFormOptions {
  id: string;
  enabled?: boolean;
}

export const useGetAccommodationForm = ({
  id,
  enabled = true,
}: UseGetAccommodationFormOptions) => {
  return useQuery({
    queryKey: ["accommodationForm", id],
    queryFn: () => fetchGraphQLClient(getAccommodationFormQuery, { id }),
    select: (data) => data.data?.getAccommodationForm ?? null,
    enabled: !!id && enabled,
  });
};
